<template>
  <PageForm action="edit" :resource="page" :model="model" v-if="Object.keys(page).length > 0"/>
</template>

<script>
import PageForm from '@/components/Utils/PageForm'
import * as types from '@/store/types.js'
import Page from '@/model/Page'

export default {
  components: {
    PageForm
  },
  computed: {
    page () {
      return this.$store.getters[types.ACTIVE_PAGE]
    },
    model () {
      return Page
    }
  },
  mounted () {
    this.$store.dispatch(types.ACTIVE_PAGE)
    Page.show(this.$route.params.id, {all_languages: true}).then((response) => {
      response.data.data.type_id = response.data.data.type.id
      this.$store.dispatch(types.UPDATE_PAGE, response.data.data)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/page/Edit.vue